<template>
  <CContainer fluid>
    <h3>Procesos de Inventarios</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="2" sm="2">
            <CButton 
              color="info" 
              variant="outline" 
              @click="OpenPanelImportSerials()">
              <i class="bi bi-upc-scan h1"></i>
              <span>Importaci&oacute;n Seriales</span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <RightSideBar class="bg-s3grey" size="md" :show="showPanelImportSerials">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              <span>Carga de archivo con <strong>Seriales</strong></span>
            </CCardTitle>
            <CCardSubtitle>
              <small>
                Este proceso permite cargar un archivo de excel con los seriales de los productos y su respectivo documento.
                En caso que requiera saber la estructura del archivo excel, vaya a la seccion de ayuda y descargue la plantilla.
              </small>
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="serials_fields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success"
                :class="isValidForm ? '' : 'disabled'"
                :disabled="!isValidForm"
                @click="(event) => processFileSerials(event)">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Grabar</span>
                <CSpinner 
                  size="sm" 
                  class="align-middle mx-2" 
                  v-show="processing" />
              </CButton>
              <CButton 
                color="danger" 
                variant="outline" 
                class="ml-2"
                @click="showPanelImportSerials = false">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>
  </CContainer>
</template>

<script>
  import { toBase64 } from "@/general";
  import { processSerialFile } from "@/apiProcess";
  import RightSideBar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";
  
  export default {
    name: "InventoryProcess",
    data() {
      return {
        processing: false,
        showPanelImportSerials: null,
        serials_fields: [
          {
            key: "tipoDocumento",
            label: "Tipo Documento",
            type: "select",
            value: "",
            options: [
              {
                label: "Seleccionar",
                value: ""
              },
              {
                label: "Entrega Mercancia",
                value: "EntregaMercancia"
              },
              {
                label: "Factura Venta",
                value: "FacturaVenta"
              },
              {
                label: "Nota Credito Venta",
                value: "NotaCreditoVenta"
              },
              {
                label: "Factura Compra",
                value: "FacturaCompra"
              }
            ],
            required: true
          },
          {
            key: "prefijo",
            label: "Prefijo",
            type: "text",
            value: ""
          },
          {
            key: "numero",
            label: "Numero",
            type: "text",
            value: "",
            required: true
          },
          {
            key: "archivo",
            label: "Archivo",
            type: "file",
            value: "",
            required: true
          }
        ]
      }
    },
    components: {
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      OpenPanelImportSerials() {
        this.showPanelImportSerials = true
      },
      async processFileSerials(e) {
        e.preventDefault();
        e.stopPropagation();

        this.processFileSerials = true;

        try {
          let fileName = this.serials_fields[3].value[0].name;
          let fileBase64 = await toBase64(this.serials_fields[3].value).then(file => file);
          let dataSerials = {
            "Tipo_Documento": this.serials_fields[0].value,
            "Prefijo": this.serials_fields[1].value ? this.serials_fields[1].value : null,
            "Numero": this.serials_fields[2].value,
            "Nombre_Archivo": fileName,
            "Archivo_Base64": fileBase64
          };

          const { errorCode, errorMessage } = await processSerialFile(this, dataSerials);

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: `El archivo ${fileName} se envio a procesar exitosamente.`,
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: errorMessage,
              show: 5
            });
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.processFileSerials = false;
          this.showPanelImportSerials = false;
        }
      }
    },
    computed: {
      isValidForm() {
        return this.serials_fields.every(field => {
          if (field.required) {
            if (typeof field.value === "string") {
              return field.value.length > 0;
            }
            if (typeof field.value === "object") {
              return field.value.length > 0;
            }
          }

          return true;
        });
      }
    },
    setup() {
      console.log("Este es el setup...");
    },
    mounted() {
      console.log("Este es el mounted");
    }
  };
</script>
